import { render } from "./IPButton.vue?vue&type=template&id=b679842c"
import script from "./IPButton.vue?vue&type=script&lang=js"
export * from "./IPButton.vue?vue&type=script&lang=js"

import "./IPButton.vue?vue&type=style&index=0&id=b679842c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__